"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileRoutes = void 0;
exports.fileRoutes = [
    {
        name: 'file.get',
        path: '/:id',
        method: 'GET'
    }
];
